export default __webpack_public_path__ + "static/media/zarokh.df95ca8a.png";